
export const updateFilterInformation = (value) => {
	return {
		type: 'UPDATE_SERIES_FILTER_INFORMATION',
		payload: {
			filterInformation: value,
		},
	};
};
